import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    accordions: {
        borderBottom: '1px solid rgba(0, 0, 0, 0.8)',
        borderRadius: '4px',
    },
}));

export default useStyles;